export const frontStyleOnstreetDeliverySelector = ({frontStyleOnstreetDelivery}) => frontStyleOnstreetDelivery